var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cart-count"},[_vm._v(" "+_vm._s(_vm.quantityFormatter(_vm.$store.getters.cartTotalCount)))])
}
var staticRenderFns = []

export { render, staticRenderFns }